import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as BaseIngredientCategoryList from 'types/_general/Store/BaseIngredientCategoryList';

const rb = new ReducerBuilder<BaseIngredientCategoryList.Type>();

export const createBaseIngredientCategoriesLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'BaseIngredientCategories/LoadedFromBackend'
);

export const baseIngredientCategoriesReducer = rb.createReducer();
